module.exports = __WEBPACK_EXTERNAL_MODULE_130__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 130
// module chunks = 0